import { jsx as _jsx } from "react/jsx-runtime";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
/**
 * Add currency format.
 *
 * @param {string} value
 * @return {string}
 */
const currencyFormat = (value) => value.replace(/(\d)(?=((\d){3})+(?:\.\d+)*$)/g, '$1.');
/**
 * Clear currency format.
 *
 * @param {string} value
 * @return {string}
 */
const currencyFormatClear = (value) => value.replace(/\D/g, '');
class ComponentInput extends Component {
    constructor(props) {
        super(props);
        // The value in state is used for display in the component.
        this.state = { value: props.defaultValue };
        // The value on the object is used for export.
        this.value = props.defaultValue;
        this.onChange = this.onChange.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
        this.setValue = this.setValue.bind(this);
        this.clear = this.clear.bind(this);
    }
    /**
     * On change event listener.
     *
     * Updates the internal value. If a currency field, the value is formatted.
     *
     * @param {string} input
     *   The value of the input.
     */
    onChange(input) {
        const { isCurrency } = this.props;
        let value = input;
        if (isCurrency) {
            // Remove the existing format.
            value = currencyFormatClear(value);
            // Apply new currency format.
            value = currencyFormat(value);
        }
        this.value = value;
        this.setState({ value });
    }
    onBlur() {
        const { onChange } = this.props;
        if (onChange) {
            onChange(this.value);
        }
    }
    onKeyPress(value) {
        const { onKeyPress } = this.props;
        if (onKeyPress) {
            onKeyPress(value);
        }
    }
    /**
     * Setter for value.
     *
     * @param {string} value
     *   The value to set.
     * @param {boolean} isCurrency
     *   If the value to set should be currency formatted.
     */
    setValue(value, isCurrency = false) {
        this.value = value;
        const newValue = isCurrency ? currencyFormat(value) : value;
        this.setState({ value: newValue });
    }
    /**
     * Clear the input.
     */
    clear() {
        const { defaultValue } = this.props;
        this.value = defaultValue;
        this.setState({ value: defaultValue });
    }
    render() {
        const { value } = this.state;
        const { type, required, error, placeholder } = this.props;
        return (_jsx("input", { id: "input", onKeyPress: (event) => this.onKeyPress(event.currentTarget.value), onChange: (event) => this.onChange(event.currentTarget.value), onBlur: this.onBlur, type: type, value: value, required: required, className: error ? 'is-invalid-input' : '', placeholder: placeholder }));
    }
}
ComponentInput.propTypes = {
    error: PropTypes.bool,
    isCurrency: PropTypes.bool,
    defaultValue: PropTypes.string,
    onChange: PropTypes.func,
    onKeyPress: PropTypes.func,
    required: PropTypes.bool,
    type: PropTypes.string,
    placeholder: PropTypes.string
};
ComponentInput.defaultProps = {
    error: false,
    isCurrency: false,
    defaultValue: '',
    required: false,
    type: 'text'
};
export default ComponentInput;
